const Distributions = Object.freeze({
  TakeAway: 1,
  Delivery: 2,
  OnLocation: 3,
})

export default Distributions
